import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";

/**
 * TODO: копия из portal-next-strapi
 *
 * Проверяет, равен ли url текущему. Query-параметры и hash не влияют на сравнение.
 * @param url - относительный путь или полный url страницы (/path или https://pochta.ru/path)
 */
var isActiveUrl = function isActiveUrl(url) {
  if (!url) return false;

  if (typeof window !== "undefined") {
    try {
      var _window$location = window.location,
          hostname = _window$location.hostname,
          pathname = _window$location.pathname,
          origin = _window$location.origin;
      var fullUrl = new URL(url, origin);
      return hostname === fullUrl.hostname && pathname === fullUrl.pathname;
    } catch (error) {
      console.warn(error);
    }
  }

  return false;
};

export default isActiveUrl;